/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {IceIceYetiServerDataParser} from "../IceIceYetiServerDataParser";
import {IWildInfo} from "../IWildInfo";
import {IIceIceYetiParsedServerData} from "./IIceIceYetiParsedServerData";
import {IIceIceYetiGameData} from "./IIceIceYetiServerData";
import {IReelsWin} from "../IReelsWin";

export class IceIceYetiParsedGameData extends SpinParsedGameData implements IIceIceYetiParsedServerData {

    private readonly _overlayWildsBeforeSpin:boolean[][];
    private readonly _overlayWildsAfterSpin:boolean[][];
    private readonly _overlaySymbolsBeforeSpin:string[][];
    private readonly _overlaySymbolsAfterSpin:string[][];
    private readonly _activeGameAreaBeforeSpin:boolean[][];
    private readonly _activeGameAreaAfterSpin:boolean[][];
    private readonly _wildInfoList:IWildInfo[];
    private readonly _reelsWin:IReelsWin[];
    private readonly _allWinPositions:boolean[][];
    private readonly _nearWinReelsIntense:boolean[];
    private readonly _randomFeatureTriggered:boolean;
    private readonly _randomFeatureOpenPositions:PIXI.Point[] | null;
    private readonly _activeGameAreaAfterRandomTrigger:boolean[][];

    constructor(rawData:IIceIceYetiGameData, dataParser:IceIceYetiServerDataParser) {
        super(rawData, dataParser);
        this._overlayWildsBeforeSpin = dataParser.parseOverlayWildsBeforeSpin(rawData);
        this._overlayWildsAfterSpin = dataParser.parseOverlayWildsAfterSpin(rawData);
        this._overlaySymbolsBeforeSpin = dataParser.parseOverlaySymbolsBeforeSpin(rawData);
        this._overlaySymbolsAfterSpin = dataParser.parseOverlaySymbolsAfterSpin(rawData);
        this._activeGameAreaBeforeSpin = dataParser.parseActiveGameAreaBeforeSpin(rawData);
        this._activeGameAreaAfterSpin = dataParser.parseActiveGameAreaAfterSpin(rawData);
        this._wildInfoList = dataParser.parseWildInfoList(rawData.wildInfoList);
        this._reelsWin = dataParser.parseReelWinPositions(rawData);
        this._allWinPositions = dataParser.parseAllWinPositions(rawData);
        this._nearWinReelsIntense = dataParser.parseNearWinReelsIntense(rawData);
        this._randomFeatureTriggered = dataParser.parseRandomFeatureTriggered(rawData);
        this._randomFeatureOpenPositions = dataParser.parseRandomFeatureOpenPositions(rawData);
        this._activeGameAreaAfterRandomTrigger = dataParser.parseActiveGameAreaAfterRandomTrigger(rawData);
    }

    get overlayWildsBeforeSpin():boolean[][] {
        return this._overlayWildsBeforeSpin;
    }

    get overlayWildsAfterSpin():boolean[][] {
        return this._overlayWildsAfterSpin;
    }

    get activeGameAreaBeforeSpin():boolean[][] {
        return this._activeGameAreaBeforeSpin;
    }

    get activeGameAreaAfterSpin():boolean[][] {
        return this._activeGameAreaAfterSpin;
    }

    get overlaySymbolsBeforeSpin():string[][] {
        return this._overlaySymbolsBeforeSpin;
    }

    get overlaySymbolsAfterSpin():string[][] {
        return this._overlaySymbolsAfterSpin;
    }

    get wildInfoList():IWildInfo[] {
        return this._wildInfoList;
    }

    get allWinPositions():boolean[][] {
        return this._allWinPositions;
    }

    get nearWinReelsIntense():boolean[] {
        return this._nearWinReelsIntense;
    }

    get randomFeatureTriggered():boolean {
        return this._randomFeatureTriggered;
    }

    get randomFeatureOpenPositions():PIXI.Point[] | null {
        return this._randomFeatureOpenPositions;
    }

    get activeGameAreaAfterRandomTrigger():boolean[][] {
        return this._activeGameAreaAfterRandomTrigger;
    }

    get reelsWin():IReelsWin[] {
        return this._reelsWin;
    }
}